export const SUMMARY = 'summary';
export const COMPARISON = 'comparison';

export const AI_PROMPT_TYPES = [
  { name: 'Summary', id: SUMMARY },
  { name: 'Comparison', id: COMPARISON },
];

export const AI_PROMPT_TYPE_FILTER_OPTIONS = AI_PROMPT_TYPES;

export const AI_PROMPT_PUBLISHED_FILTER_OPTIONS = [
  { name: 'Yes', id: 'true' },
  { name: 'No', id: 'false' },
];

export const AI_PROMPT_TARGET_OBJECTS = [
  { name: 'Concurrent Review', id: 'Review::Authorization' },
  { name: 'Referral', id: 'Review::Referral' },
  { name: 'Workspace', id: 'Summarization' },
];

export const AI_PROMPT_TARGET_OBJECT_FILTER_OPTIONS = AI_PROMPT_TARGET_OBJECTS;
